"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = DisclosureModal;
var _react = _interopRequireDefault(require("react"));
var _reactBlueprintLibrary = require("react-blueprint-library");
var _htmlReactParser = _interopRequireDefault(require("html-react-parser"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function DisclosureModal(_ref) {
  var {
    handleClose,
    show,
    textArray
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Modal, {
    size: "lg",
    show: show
  }, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Modal.Header, {
    onClose: () => handleClose(),
    title: "Disclosures & Assumptions"
  }), /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Modal.Body, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "container"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "row"
  }, textArray.map((text, i) => {
    return /*#__PURE__*/_react.default.createElement(TextSpan, {
      key: i,
      text: (0, _htmlReactParser.default)(text),
      lastStep: i == textArray.length - 1
    });
  }))))));
}
function TextSpan(_ref2) {
  var {
    text,
    lastStep
  } = _ref2;
  if (lastStep) {
    return /*#__PURE__*/_react.default.createElement("span", null, text);
  }
  return /*#__PURE__*/_react.default.createElement("p", null, text);
}